import React from 'react';
import { Instagram, Facebook } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-stone-900 text-stone-400 py-12 border-t border-stone-800" data-id="element-92">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-93">
        <div className="mb-8" data-id="element-94">
          <div className="text-2xl font-extrabold text-white font-heading mb-2" data-id="element-95">
            AULA DE ÉXITOS
          </div>
          <p className="text-stone-300 font-medium max-w-md mx-auto" data-id="element-96">
            El sistema de planificación N°1 para maestras y maestros del Tramo 2
            (EBI) en Uruguay.
          </p>
          <p className="text-celeste-400 mt-2 font-medium" data-id="element-97">
            Porque enseñar no debería costarte todos los fin de semana de el
            año.
          </p>
        </div>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 mb-10 text-sm" data-id="element-98">
          <a href="mailto:contacto@tufenixdigital.store" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-99">
            tufenixdigital@gmail.com
          </a>
          <a href="https://aula.tufenixdigital.store" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-100">
            🌐 aula.tufenixdigital.store
          </a>
          <a href="https://www.instagram.com/tufenixdigital_oficial/" target="_blank" rel="noopener noreferrer" aria-label="Seguinos en Instagram" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-101">
            <Instagram className="w-4 h-4" data-id="element-102" />
            @tufenixdigital_oficial
          </a>
          <a href="https://www.facebook.com/people/Tu-Fenix-Digital/61590759474336/" target="_blank" rel="noopener noreferrer" aria-label="Seguinos en Facebook" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-103">
            <Facebook className="w-4 h-4" data-id="element-104" />
            Tu Fénix Digital
          </a>
        </div>

        <div className="text-xs border-t border-stone-800 pt-8 space-y-4" data-id="element-105">
          <p data-id="element-106">
            © Aula de Éxitos 2026 - Tu Fénix Digital - Todos los derechos
            reservados. Prohibida la reproducción y redistribución sin
            autorización expresa.
          </p>
          <p className="text-stone-500 font-medium" data-id="element-107">
            "El próximo fin de semana puede ser diferente." ES UN HECHO.
          </p>
        </div>
      </div>
    </footer>;
};